import type { SYSState } from "../../../../_ovlclient/src"
import {
  versionInfo,
  type AppDefDialog,
  type AppDefPermission,
  type AppDefScreen,
  type AppDefTableDefId,
  type SYSConfigType,
} from "../../../../_ovlclient/src/config"
import { isIOS } from "../../../../_ovlclient/src/global/globals"

import { ProcessSnackType } from "../../../../_ovlclient/src/library/longrunningprocesstracker/longrunningprocesstracker"
import { appActions } from "./appactions"
export { appState } from "./appstate"
export { appActions }

export let app = {
  features: {
    SYSTableSettingsSaveFilterSortAll: {},
    SYSTableSettingsSaveFilterSortCompany: {},
    SYSTableSettingsSaveFilterSortOwn: {},
    SYSTableSettingsReadOnlyFilterSort: {},
    DATSalesOrders: {},
    DATQuotations: {},
    DATInvoices: {},
    QUTOfferingTool: {},
    QUTOfferingToolAdmin: {},
    KPIProductionDataAdmin: {},
    KPIUser: {},
    PKGPackaging: {},
    PKGPackagingSplit: {},
    SPCSymbolPCEndUser: {},
    SPCSymbolPC: {},
  },
  permissions: {
    /* Data */
    DATDA: <AppDefPermission>{ useModifiers: false },
    /* Packaging */
    PKGPK: <AppDefPermission>{ useModifiers: false },
    /* SymbolPC */
    SPCSP: <AppDefPermission>{ useModifiers: true },
    //Search Paket
    SPKSP: <AppDefPermission>{ useModifiers: false },
    //Offering
    QUTOF: <AppDefPermission>{ useModifiers: true },
    /* KPI */
    KPIPR: <AppDefPermission>{ useModifiers: true },
    KPIUS: <AppDefPermission>{ useModifiers: false },
  },

  dialogs: {
    GENImagePopup: <AppDefDialog>{},
    PKGPackagingSplit: <AppDefDialog>{},
    SYSTableSettings_AdvancedFilter: <AppDefDialog>{},
    QUTOfferingPos: <AppDefDialog>{},
  },
  longRunningProcess: {
    QUTOfferingPosProductionExport: {
      snack: <ProcessSnackType>{ type: "BusyIndicator" },
    },
    GENRefreshData: { snack: <ProcessSnackType>{ type: "BusyIndicator" } },
    KPIDataRefresh: { snack: <ProcessSnackType>{ type: "BusyIndicator" } },
    GENSaveFeedback: { snack: <ProcessSnackType>{ type: "BusyIndicator" } },
    GENSaveSettings: { snack: <ProcessSnackType>{ type: "BusyIndicator" } },
    PKGPackagingPackagingPrintLabel: {
      snack: <ProcessSnackType>{ type: "BusyIndicator" },
    },
    PKGPackagingPackagingSplit: {
      snack: <ProcessSnackType>{ type: "BusyIndicator" },
    },
    PKGPackagingPackagingUnSplit: {
      snack: <ProcessSnackType>{ type: "BusyIndicator" },
    },

    OfferingStatus: {},
    QUTOfferingOfferingEmailNotification: {},
    QUTOfferingOfferingPDFDownloading: {
      snack: <ProcessSnackType>{ type: "BusyIndicator" },
    },
    GENNewOfferUpload: {
      snack: <ProcessSnackType>{ type: "BusyIndicator" },
    },
    QUTOfferingRecalcStatus: { lockScreen: true },

    QUTOfferingOfferingAcceptOfferSnack: {
      snack: <ProcessSnackType>{ type: "BusyIndicator" },
    },
  },
  forms: {
    DATFeedback: {},
    DATSearchPaket: {},
    QUTOfferingSettings: {},
    QUTBPFilter: {},
    QUTAdminUploadForm: {},
  },
  tableDefIds: {
    DATSearchPaket: <AppDefTableDefId>{
      getData: (state: SYSState) => state.app.global.DAT.tables.DATSearchPaket,
    },

    PKGPackaging: <AppDefTableDefId>{
      getData: (state: SYSState) => state.app.global.PKG.tables.PKGPackaging,
    },

    PKGPackagingSplit: <AppDefTableDefId>{
      getData: (state: SYSState) =>
        state.app.global.PKG.tables.PKGPackagingSplit,
    },

    SPCSymbolPC: <AppDefTableDefId>{
      getData: (state: SYSState) => state.app.global.SPC.tables.SPCSymbolPC,
    },
    SPCSymbolPCEndUser: <AppDefTableDefId>{
      getData: (state: SYSState) => state.app.global.SPC.tables.SPCSymbolPC,
    },
    QUTOffering: {
      getData: (state: SYSState) => state.app.global.QUT.tables.QUTOffering,
    },
    QUTOfferingActual: {
      getData: (state: SYSState) => state.app.global.QUT.tables.QUTOffering,
    },

    //currently used for offering type "CUT" and the user uploadable and editable poslist
    QUTOfferingPos: {
      getData: (state: SYSState) => state.app.global.QUT.tables.QUTOfferingPos,
    },

    QUTOfferingSettings: {
      getData: (state: SYSState) =>
        state.app.global.QUT.tables.QUTOfferingSettings,
    },
    QUTOfferingCosts: {
      getData: (state: SYSState) =>
        state.app.global.QUT.tables.QUTOfferingCosts,
    },
    QUTOfferingMaterial: {
      getData: (state: SYSState) =>
        state.app.global.QUT.tables.QUTOfferingMaterial,
    },
    QUTOfferingTransport: {
      getData: (state: SYSState) =>
        state.app.global.QUT.tables.QUTOfferingTransport,
    },
    QUTOfferingAdminUpload: {
      getData: (state: SYSState) =>
        state.app.global.QUT.tables.QUTOfferingAdminUpload,
    },
  },

  languages: { DE: {}, FR: {} },
  screens: {
    GENDashboard: <AppDefScreen>{},
    GENSettings: <AppDefScreen>{},
    KPIAll: <AppDefScreen>{},
    DATQuotation: <AppDefScreen>{},
    DATOrder: <AppDefScreen>{},
    DATInvoice: <AppDefScreen>{},
    DATOrderdetail: <AppDefScreen>{},
    DATFeedback: <AppDefScreen>{},
    DATSearchPaket: <AppDefScreen>{},
    PKGPackaging: {},
    PKGPackagingCustomerChooser: {},
    QUTOffering: <AppDefScreen>{},
    QUTOfferingAdmin: <AppDefScreen>{},
    QUTOfferingAdminCut: <AppDefScreen>{},
    QUTOfferingDetails: <AppDefScreen>{},
    SPCSymbolPC: {},
    SPCSymbolPCEndUser: {},
  },
  customValidators: {},
  editors: {},
}
export let SYSConfig: SYSConfigType = {
  _system: {
    debugTracking: false,
    versionInfo,
    isDev: false,
    autoAddMissingTranslationsInDevMode: true,
    showSaveOrigin: true,
    statePersistVersion: 1,
    defaultDateTimeControlSubmitType: "UTC",
    suppressAfterRenderIfGetUIEmpty: true,
    appId: "001",
  },
  init: { initalScreen: "GENDashboard" },
  app,

  formDefaults: {
    showErrorWhileTyping: false,
  },
  tableDefaults: {
    tableControlsMode: "AllButPageTopBottom",
    rendering: { cellAlignment: "top", zebra: "vertical" },
  },
  fetch: {
    timeout: 5000,
  },
  global: {
    stickyHeaderEnabled: (state: SYSState) => {
      return !isIOS()
    },
  },
}
